export const mobileBreakpoint = {
  mobile: `(max-width: 450px)`,
  mobileS: `(max-width: 390px)`,
};